import React from "react";

const IllustrationFrame = ({ children, testId }) => (
  <div className="relative h-32 overflow-hidden rounded-[1.55rem] border border-white/70 bg-[linear-gradient(180deg,_rgba(255,255,255,0.82)_0%,_rgba(240,253,244,0.95)_100%)] p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.75)]" data-testid={testId}>
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(190,242,100,0.22),_transparent_28%),radial-gradient(circle_at_bottom_left,_rgba(94,234,212,0.18),_transparent_28%)]" />
    <div className="relative h-full">{children}</div>
  </div>
);

const MicroAxis = () => <div className="absolute inset-x-0 bottom-2 h-px bg-gradient-to-r from-transparent via-[#0f766e]/25 to-transparent" />;

export const ServiceMicroIllustration = ({ type, testId }) => {
  if (type === "bim3d-synthesis") {
    return (
      <IllustrationFrame testId={testId}>
        <div className="absolute left-5 top-5 h-12 w-12 border-2 border-[#0f766e]/70 [transform:skewY(-24deg)]" />
        <div className="absolute left-[4.45rem] top-[1.05rem] h-12 w-12 border-2 border-[#2dd4bf]/80 [transform:skewY(-24deg)]" />
        <div className="absolute left-[3.2rem] top-[2.5rem] h-12 w-12 border-2 border-[#84cc16]/80 [transform:skewY(-24deg)]" />
        <div className="absolute right-6 top-5 h-10 w-14 rounded-[1rem] border border-[#0f766e]/30 bg-white/70" />
        <div className="absolute right-[5.9rem] top-9 h-px w-8 bg-[#0f766e]/45" />
        <div className="absolute right-[8.5rem] top-[1.95rem] flex h-4 w-4 items-center justify-center rounded-full bg-[#fde047] text-[10px] font-bold text-[#0f766e]">×</div>
        <div className="absolute right-5 bottom-5 space-y-2">
          <div className="h-2.5 w-16 rounded-full bg-[#2dd4bf]/80" />
          <div className="h-2.5 w-12 rounded-full bg-[#84cc16]/75" />
          <div className="h-2.5 w-20 rounded-full bg-[#fde047]/70" />
        </div>
        <MicroAxis />
      </IllustrationFrame>
    );
  }

  if (type === "bim4d-planning") {
    return (
      <IllustrationFrame testId={testId}>
        <div className="absolute left-5 top-5 h-12 w-10 rounded-t-[1rem] bg-gradient-to-b from-[#0f766e] to-[#2dd4bf]" />
        <div className="absolute left-[4.2rem] top-8 h-9 w-8 rounded-t-[0.8rem] bg-gradient-to-b from-[#84cc16] to-[#bef264]" />
        <div className="absolute left-5 top-16 h-2 w-32 rounded-full bg-[#0f766e]/15" />
        <div className="absolute right-5 top-4 space-y-2">
          <div className="h-2.5 w-20 rounded-full bg-[#2dd4bf]" />
          <div className="h-2.5 w-16 rounded-full bg-[#84cc16]" />
          <div className="h-2.5 w-24 rounded-full bg-[#fde047]" />
        </div>
        <div className="absolute left-4 top-8 h-px w-[78%] bg-[#0f766e]/25" />
        {["left-4", "left-[30%]", "left-[54%]", "left-[78%]"].map((leftClass, index) => (
          <span className={`absolute ${leftClass} bottom-[1.35rem] h-3 w-3 rounded-full ${index % 2 === 0 ? "bg-[#2dd4bf]" : "bg-[#84cc16]"}`} key={leftClass} />
        ))}
        <div className="absolute left-5 bottom-6 h-2.5 w-24 rounded-full bg-[#fde047]" />
        <div className="absolute left-[8rem] bottom-6 h-2.5 w-14 rounded-full bg-[#84cc16]" />
        <div className="absolute right-5 top-5 h-14 w-14 rounded-full border border-[#0f766e]/15 bg-white/70">
          <div className="absolute inset-[22%] rounded-full border-2 border-[#0f766e]/55" />
          <div className="absolute left-1/2 top-[26%] h-4 w-[2px] -translate-x-1/2 rounded-full bg-[#0f766e]" />
          <div className="absolute left-[52%] top-1/2 h-[2px] w-3 rounded-full bg-[#0f766e]" />
        </div>
      </IllustrationFrame>
    );
  }

  if (type === "training") {
    return (
      <IllustrationFrame testId={testId}>
        <div className="absolute left-6 top-5 h-14 w-16 rounded-[1rem] border border-[#0f766e]/25 bg-white/80" />
        <div className="absolute left-[5.6rem] top-7 h-10 w-12 rounded-[0.9rem] border border-[#84cc16]/30 bg-white/80" />
        <div className="absolute left-[3.4rem] top-[2.55rem] h-px w-9 bg-[#0f766e]/40" />
        <div className="absolute right-6 top-6 h-3 w-20 rounded-full bg-[#2dd4bf]" />
        <div className="absolute right-6 top-12 h-3 w-14 rounded-full bg-[#84cc16]" />
        <div className="absolute right-6 top-[4.5rem] h-3 w-18 rounded-full bg-[#fde047]" />
        <MicroAxis />
      </IllustrationFrame>
    );
  }

  return (
    <IllustrationFrame testId={testId}>
      <div className="absolute left-5 top-5 grid grid-cols-2 gap-3">
        <div className="h-10 w-14 rounded-[1rem] bg-[#0f766e]/90" />
        <div className="h-10 w-10 rounded-[1rem] bg-[#2dd4bf]/80" />
        <div className="h-8 w-12 rounded-[1rem] bg-[#84cc16]/80" />
        <div className="h-8 w-16 rounded-[1rem] bg-[#fde047]/80" />
      </div>
      <div className="absolute right-5 top-6 space-y-2">
        <div className="h-2.5 w-16 rounded-full bg-[#0f766e]/80" />
        <div className="h-2.5 w-12 rounded-full bg-[#2dd4bf]/80" />
        <div className="h-2.5 w-20 rounded-full bg-[#84cc16]/80" />
      </div>
      <MicroAxis />
    </IllustrationFrame>
  );
};